('use strict');
var { slugify } = require('react-shared/utils/string');

var HTTPService = require('../services/http-service');
var NotificationService = require('../services/notification-service');
var blzEvent = require('../services/tracking/blz-event.js');
var { pushEvent } = require('./dataLayerEC');
var Modal = require('./modal');
var util = require('../services/tracking/blz-tracking-util');

var Newsletter = {
  subscribe: function subscribe(event, callback) {
    event && event.preventDefault();

    var $newsletterForm = $(event.target).closest('form');
    var formAction = $newsletterForm.attr('action') || '/api/account/newsletter';
    var $name = $newsletterForm.find('[name=name]');
    var $familyName = $newsletterForm.find('[name=familyName]');
    var $email = $newsletterForm.find('[name=email]');
    var $gender = $newsletterForm.find('[name=gender]:checked');
    var $partner = $newsletterForm.find('[name=partner]:checked');
    var $utm_campaign = $newsletterForm.find('[name=utm_campaign]');
    var $_csrf = $newsletterForm.find('[name=_csrf]');

    var data = {
      email: $email.val(),
      gender: ($gender.val() || $(this).data('gender') || '').toUpperCase(),
      name: $name.val(),
      familyName: $familyName.val() || '',
      partner: $partner.val() === 'true',
      _csrf: $_csrf.val(),
      utm_campaign: $utm_campaign.val() || ''
    };

    if (!data.name || !data.email) {
      return NotificationService.warning('Preencha nome e email para receber promoções incríveis!');
    }

    if (!/^[a-zA-Z0-9][a-zA-Z0-9._-]+@([a-zA-Z0-9._-]+\.)[a-zA-Z-0-9]{2,3}$/.test(data.email)) {
      pushEvent('cadastrar:callback', 'cadastro-newsletter:email-invalido', 'home');
      return NotificationService.warning('Preencha um email válido!');
    }

    Newsletter.sendEvent(data);

    HTTPService.post(formAction, data)
      .then(HTTPService.handleClientError)
      .then(function () {
        pushEvent('cadastrar:callback', 'cadastro-newsletter:sucesso', 'home');
        NotificationService.success(
          'E-mail cadastrado com sucesso! Em breve receberá promoções incríveis'
        );

        if (typeof callback === 'function') {
          callback();
        }
      })
      .catch((error) => {
        const msg = HTTPService.parseFirstError(error);
        pushEvent('cadastrar:callback', `cadastro-newsletter:${slugify(msg)}`, 'home');
        NotificationService.error(error);
      });
  },

  openOnModal: function (uri, onClose) {
    var hasClosed = util.readCookie('newsletter-closed-' + uri);
    var hasSubscribed = util.readCookie('newsletter-subscribed-' + uri);

    if (hasClosed || hasSubscribed) return;

    blzEvent.interaction(event, {
      category: (blz.pageName || '').toUpperCase(),
      action: 'Modal-Open',
      label: 'Newsletter-Modal-' + uri
    });

    Modal.open({
      title: 'Promoções exclusivas!',
      body:
        '<div class="lazyload" id="' +
        uri +
        '" data-include="/api/htmls/newsletter/' +
        uri +
        '"></div>',
      windowTopClass: 'modal-without-padding',
      onClose: function () {
        blzEvent.interaction(event, {
          category: (blz.pageName || '').toUpperCase(),
          action: 'Modal-Close',
          label: 'Newsletter-Modal-' + uri
        });

        if (typeof onClose === 'function') {
          onClose();
        }
      }
    });
  },

  sendEvent: function (data) {
    blzEvent.interaction(
      {},
      {
        category: (blz.pageName || '').toUpperCase(),
        action: 'Button-Click',
        label: 'Register-Newsletter',
        values: 'email;' + data.email
      }
    );
  }
};

$(document).on('click tap', '.form-newsletter .js-newsletter-btn', Newsletter.subscribe);

blz.newsletter = function (opts) {
  if (!opts.onlyIf || !opts.id) return;

  function onSubscribe(event) {
    Newsletter.subscribe(event, function () {
      Modal.close();
      opts.onSubscribe && opts.onSubscribe();
    });
  }

  function onClose() {
    var DAYS_HIDDEN = (opts.daysHidden || 1) * 24 * 60 * 60 * 1000;
    document.cookie = util.setCookie('newsletter-closed-' + opts.id, 'true', DAYS_HIDDEN);
  }

  $(document).on('click tap', '#' + opts.id + ' .js-newsletter-btn', onSubscribe);

  setTimeout(function () {
    Newsletter.openOnModal(opts.id, onClose);
  }, opts.showAfter || 0);
};

module.exports = Newsletter;
